/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../../components/Translate/I18n';
import Button from '@material-ui/core/Button';
import MsisdnChooseNumberList from './MsisdnChooseNumberList';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';

class MsisdnPoolChooseDialog extends Component {
    onClicked = (v) => {
        this.props.callBackSetMsisdn(v);
    };

    render() {
        const { open, callbackClose, platformResellerId } = this.props;
        return (
            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={open}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    <GridContainer justifyContent={'space-between'}>
                        <h4>
                            <I18n trans="pools:pool.choose_msidn" />
                        </h4>
                        <Button onClick={callbackClose} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" />
                    <GridContainer>
                        <GridItem xs={12}>
                            <MsisdnChooseNumberList clicked={this.onClicked} platformResellerId={platformResellerId} />
                        </GridItem>
                    </GridContainer>
                </DialogContent>
            </Dialog>
        );
    }
}

MsisdnPoolChooseDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    callbackClose: PropTypes.func,
    callBackSetMsisdn: PropTypes.func.isRequired,
    platformResellerId: PropTypes.number.isRequired,
};

const enhance = compose(connect(), withStyles(adescomStyle));
const Enhance = enhance(MsisdnPoolChooseDialog);
export default Enhance;
